import React from 'react';
import { useI18n } from '../../../../contexts/I18nContext';
import './Veo2Features.scss';

const Veo2Features = () => {
  const { t } = useI18n();
  const items = t('videoGeneration.veo.features.items');
  return (
    <section className="veo2-features">
      <div className="veo2-features__inner">
        <h2 className="veo2-features__title">{t('videoGeneration.veo.features.title')}</h2>
        <p className="veo2-features__subtitle">{t('videoGeneration.veo.features.subtitle')}</p>
        <div className="veo2-features__grid">
          {items.map((it) => (
            <article key={it.num} className="veo2-feature">
              <span className="veo2-feature__num">{it.num}</span>
              <h3 className="veo2-feature__title">{it.title}</h3>
              <p className="veo2-feature__body">{it.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Veo2Features;